// extracted by mini-css-extract-plugin
export default {"tldrawBorderWrapper":"DrawingInputField__tldrawBorderWrapper___X7GCw","tldrawAppContainer":"DrawingInputField__tldrawAppContainer___Jcpuv"};